<template>
  <div class="confirm-and-create">
    <div class="titulo"></div>

    <div class="card-box full">
      <div class="center">
        <h1>Confirmar Dados</h1>
      </div>

      <form @submit="submitHandler">
        <div v-if="status === STATUS_WAITING">
          <p>
            Agora é o momento onde vamos confirmar seus dados.
          </p>
          <p>
            Se está certo de que os dados informados estão todos corretos, clique em continuar, mas
            caso haja alguma dúvida, não tem problema, basta clicar na seta para voltar à tela
            anterior.
          </p>
          <p class="contract">
            <CheckBox v-model="termsAccepted">
              Li e concordo com os
              <a
                class="contract-link"
                href="https://www.padmoney.com/termos-de-uso"
                target="_blank"
                @click="$event.stopPropagation()"
              >
                Termos e Condições de Uso
              </a>
              do Padmoney.
            </CheckBox>
            <CheckBox v-model="privacyPolicyAccepted">
              Li e concordo com a
              <a
                class="contract-link"
                href="https://www.padmoney.com/politica-de-privacidade"
                target="_blank"
                @click="$event.stopPropagation()"
              >
                Política de Privacidade
              </a>
              do Padmoney.
            </CheckBox>
          </p>
          <ContinueSection
            enable-back
            :enable-continue="termsAccepted && privacyPolicyAccepted"
            @back="$emit('back')"
          />
        </div>

        <div v-else-if="STATUS_SAVING === status">
          <Loading message="Estamos salvando seus dados, por favor, aguarde." />
        </div>

        <div v-else-if="STATUS_ERROR === status">
          <br />
          <br />
          <div class="erroDados">
            {{ errorMessage }}
          </div>
          <ContinueSection enable-back :enable-continue="false" @back="$emit('back')" />
        </div>

        <div v-else-if="STATUS_SAVED === status">
          <p class="center">
            Estamos quase lá! Um último passo... Enviamos para você um e-mail e também um SMS para
            confirmação.
          </p>
          <ContinueSection />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ContinueSection from '@/components/ContinueSection'
import Loading from '@/components/Loading'
import register from '@/common/helper/register'
import CheckBox from '../components/CheckBox'

const STATUS_WAITING = 'waiting'
const STATUS_SAVING = 'saving'
const STATUS_SAVED = 'saved'
const STATUS_ERROR = 'error'

export default {
  name: 'ConfirmAndCreate',
  components: {
    CheckBox,
    Loading,
    ContinueSection
  },
  model: {
    prop: 'accountId',
    event: 'change'
  },
  props: {
    accountId: String,
    personType: String,
    company: Object,
    address: Object,
    authorization: {
      type: String,
      required: false
    },
    owner: {
      type: Object,
      required: false
    },
    partnerId: {
      type: String,
      required: false
    },
    campaignId: {
      type: String,
      required: false
    }
  },
  data: () => ({
    STATUS_WAITING,
    STATUS_SAVING,
    STATUS_SAVED,
    STATUS_ERROR,
    status: STATUS_WAITING,
    errorMessage: '',
    termsAccepted: false,
    privacyPolicyAccepted: false
  }),
  methods: {
    async submitHandler(e) {
      e.preventDefault()

      const { status } = this

      if (STATUS_WAITING === status) {
        this.register()
        return
      }

      if (STATUS_SAVED === status) {
        this.$emit('next')
      }
    },
    async register() {
      this.status = STATUS_SAVING

      const {
        partnerId, campaignId, personType, company, owner, address, authorization
      } = this

      try {
        const account = await register(
          personType,
          company,
          owner,
          address,
          partnerId,
          campaignId,
          authorization
        )
        this.$emit('change', account)
        if (authorization) {
          this.$emit('next')
        } else {
          this.status = STATUS_SAVED
        }
      } catch ({ message }) {
        this.errorMessage = message
        this.status = STATUS_ERROR
      }
    }
  }
}
</script>

<style scoped>
form p {
  font-weight: lighter;
}

form p.contract {
  font-size: 1em;
}

form p.contract a.contract-link {
  color: #158ddb;
  padding: 0 5px;
}
</style>
